
import {
 
  FETCH_SUPPLIER_REQUEST,
  FETCH_SUPPLIER_SUCCESS,
  FETCH_SUPPLIER_FAILURE,

  CREATE_SUPPLIER_REQUEST,
  CREATE_SUPPLIER_SUCCESS,
  CREATE_SUPPLIER_FAILURE,

  UPDATE_SUPPLIER_REQUEST,
  UPDATE_SUPPLIER_SUCCESS,
  UPDATE_SUPPLIER_FAILURE,

  DELETE_SUPPLIER_REQUEST,
  DELETE_SUPPLIER_SUCCESS,
  DELETE_SUPPLIER_FAILURE,
} from "./supplierActionType";

export const fetchSupplierequest = () => ({
  type: FETCH_SUPPLIER_REQUEST,
});

export const fetchSupplierSuccess = (data) => ({
  type: FETCH_SUPPLIER_SUCCESS,
  payload: data,
});

export const fetchSupplierFailure = (error) => ({
  type: FETCH_SUPPLIER_FAILURE,
  payload: error,
});

export const createSupplierRequest = () => ({
  type: CREATE_SUPPLIER_REQUEST,
});

export const createSupplierSuccess = (data) => ({
  type: CREATE_SUPPLIER_SUCCESS,
  payload: data,
});

export const createSupplierFailure = (error) => ({
  type: CREATE_SUPPLIER_FAILURE,
  payload: error,
});

export const updateSupplierRequest = () => ({
  type: UPDATE_SUPPLIER_REQUEST,
});

export const updateSupplierSuccess = (data) => ({
  type: UPDATE_SUPPLIER_SUCCESS,
  payload: data,
});

export const updateSupplierFailure = (error) => ({
  type: UPDATE_SUPPLIER_FAILURE,
  payload: error,
});

export const deleteSupplierRequest = () => ({
  type: DELETE_SUPPLIER_REQUEST,
});

export const deleteSupplierSuccess = (data) => ({
  type: DELETE_SUPPLIER_SUCCESS,
  payload: data,
});

export const deleteSupplierFailure = (error) => ({
  type: DELETE_SUPPLIER_FAILURE,
  payload: error,
});
